import packingRequest from '../request/packing'
import configServer from "../../configs/server"
import queryString from "query-string"

const apiRequest = packingRequest()

export const getListBoxes = async (args = {}) => {
    const {data} = await apiRequest({
        url: '/packing/boxes/search',
        //url: 'http://localhost:1111/boxes/search',
        method: 'POST',
        data: args
    })

    return data
}

// Cảnh báo sidebar: đếm số thùng FBA đủ 2 label chờ dán (chưa dán).
// Trả về axios response, body dạng { success, data: { total } }.
export const countFbaBoxPendingLabelled = () => {
    return apiRequest({
        url: '/packing/fba/boxes/count-pending-labelled',
        method: 'GET',
    })
}

export const searchListPackagedItems = async (args = {}) => {
    const {data} = await apiRequest({
        url: '/packing/v2/items/search',
        method: 'POST',
        data: args
    })

    return data
}

export const searchListPackagedItemsV3 = async (args = {}) => {
    const {data} = await apiRequest({
        url: '/packing/v3/items/search',
        method: 'POST',
        data: args
    })

    return data
}

export const getBoxDetail = async (boxId) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/${boxId}`,
        //url: `http://localhost:1111/boxes/${boxId}`,
        method: 'GET'
    })

    return data
}

export const getListBoxItems = async (boxId) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/${boxId}/items`,
        method: 'GET'
    })

    return data
}

export const closeBox = async (boxId, payload) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/${boxId}/close`,
        method: 'POST',
        data: payload
    })

    return data
}

export const packageByBatch = async (boxId, payload) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/${boxId}/package-by-batch`,
        method: 'POST',
        data: payload,
    })
    return data
}

export const reopenBox = async (boxId) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/${boxId}/reopen`,
        method: 'POST'
    })

    return data
}

export const createNewBox = async (type = '') => {
    const {data} = await apiRequest({
        url: `/packing/boxes`,
        method: 'POST',
        data: {
            type
        }
    })

    return data
}

export const addItemToBox = async (boxId, barcode) => {
    const {data} = await apiRequest({
        url: `/packing/v2/boxes/${boxId}/items/${barcode}`,
        method: 'POST'
    })

    return data
}

export const removeItemFromBox = async (boxId, barcode) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/${boxId}/items/${barcode}`,
        method: 'DELETE'
    })

    return data
}

export const getTotalItemStatistics = async () => {
    const {data} = await apiRequest({
        url: `/packing/statistics/total-items`,
        method: 'GET'
    })

    return data
}

export const getTotalItemStatisticsV2 = async (payload) => {
    const { data } = await apiRequest({
        url: `/packing/v2/statistics/total-items`,
        method: 'POST',
        data: payload
    })

    return data
}

export const getTotalItemStatisticsByTypes = async (args = {}) => {
    const {data} = await apiRequest({
        url: `/packing/statistics/by-types`,
        method: 'GET',
        params: args
    })

    return data
}

export const markAsShippedBox = async (boxId) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/by-number/${boxId}/shipped`,
        method: 'POST'
    })

    return data
}

export const markAsShippedBoxs = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/boxes/shipped`,
        method: 'POST',
        data: payload,
    })

    return data
}

export const getProductStatistics = async (args = {}) => {
    const {data} = await apiRequest({
        url: `/packing/statistics/products`,
        method: 'GET',
        params: args
    })

    return data
}

export const getCommitTimesStatistics = async () => {
    const {data} = await apiRequest({
        url: `/packing/barcodes/overtimed/report`,
        method: 'GET',
    })

    return data
}

export const getCommitTimesStatisticsV2 = async (args = {}) => {
    let query = Object.keys(args || {}).map(prop => {
        return args[prop] ? `${prop}=${args[prop]}` : ''
    }).filter(Boolean).join('&')

    const {data} = await apiRequest({
        url: [`/exporter/barcode/report/commitment-time`, query].filter(Boolean).join('?'),
        method: 'GET',
    })

    return data
}

export const getExportItemsCSV = (params) => {
    const baseUrl = configServer.url
    const query = queryString.stringify(params)

    return `${baseUrl}/packing/v2/items/export-csv?${query}`
}

export const getExportItemsCSVv3 = async (params) => {
    const data = await apiRequest({
        url: `/packing/v3/items/export-csv`,
        method: 'POST',
        data: params
    })

    return data
}

export const getExportItemsCSVv4 = async (params) => {
    const data = await apiRequest({
        url: `/packing/v4/items/export-csv`,
        method: 'POST',
        data: params
    })

    return data
}

export const getExportItemsCSVBySku = async (params) => {
    const data = await apiRequest({
        url: `/exporter/accounting/by-sku`,
        method: 'POST',
        data: params
    })

    return data
}

export const getExportItemsCSVByOrder = async (params) => {
    const data = await apiRequest({
        url: `/exporter/accounting/by-order`,
        method: 'POST',
        data: params
    })

    return data
}

export const receivedShipment = async (itemId) => {
    const {data} = await apiRequest({
        url: `/packing/items/${itemId}/shipment-received`,
        method: 'POST'
    })

    return data
}

export const checkTrackingBesideBarcode = async (boxId, payload) => {
    const {data} = await apiRequest({
        url: `/packing/v3/boxes/${boxId}/items`,
        method: 'POST',
        data: payload
    })

    return data
}

export const checkTrackingBesideBarcodeFBA = async (boxId, payload) => {
    const {data} = await apiRequest({
        url: `/packing/v3/boxes/${boxId}/item-fba`,
        method: 'POST',
        data: payload
    })

    return data
}

export const reGenerateLabel = async (barcodeNumber) => {
    const {data} = await apiRequest({
        url: `/packing/orders/${barcodeNumber}/request-generate-label`,
        method: 'POST'
    })

    return data
}

export const getListBoxType = async () => {
    const {data} = await apiRequest({
        url: `/packing/box/list-type`,
        method: 'GET'
    })

    return data
}

export const importTrackingDHL = (formData) => {
    return apiRequest({
        url: '/packing/box/dhl/import-tracking',
        method: 'POST',
        data: formData
    })
}

export const updateInfoBox = ({boxId, data}) => {
    return apiRequest({
        url: `/packing/boxes/${boxId}`,
        method: 'PUT',
        data
    })
}

export const validateFBAFullyBoxed = async (boxId) => {
    return apiRequest({
        url: `/packing/boxes/${boxId}/validate-fully-boxes-fba`,
        method: 'GET'
    })
}

export const importTrackingFBA = (formData) => {
    return apiRequest({
        url: '/packing/box/fba/import-tracking',
        method: 'POST',
        data: formData
    })
}

export const getExportListBoxes = (data) => {
    // const baseUrl = configServer.url
    // const query = queryString.stringify(params)

    // return `${baseUrl}/packing/boxes/export-csv?${query}`
    return apiRequest({
        url: '/packing/boxes/export-csv',
        method: 'POST',
        data
    })
}

export const getExportTrackingInfo = (data) => {
    // const baseUrl = configServer.url
    // const query = queryString.stringify(params)

    // return `${baseUrl}/packing/boxes/export-csv?${query}`
    return apiRequest({
        url: '/packing/boxes/export-tracking-csv',
        method: 'POST',
        data
    })
}

export const createLLCBoxes = (formData) => {
    return apiRequest({
        url: '/packing/llc-boxes',
        method: 'POST',
        data: formData
    })
}

export const addDiaryNextBoxes = (data) => {
    return apiRequest({
        url: '/packing/boxes/diary',
        method: 'POST',
        data
    })
}

export const bulkCreateBatchShip = (data) => {
    return apiRequest({
        url: `/packing/batch-ship/bulk-from-boxes`,
        method: 'POST',
        data
    })
}
